import React from "react";
import "./Service.css";
import { motion } from "framer-motion";

const ServiceFive = () => {
  const words = ["SAVE", "MONEY", "ON", "AUTO", "REPAIR"];
  const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2,
        duration: 0.5,
        ease: "easeOut",
      },
    }),
  };
  return (
    <div className="service-three-container">
      <div className="service-three-left">
        <h2 className="chakra-petch-bold">
          {words.map((word, i) => (
            <motion.span
              key={i}
              custom={i}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.8 }}
              variants={fadeInUp}
              style={{ display: "inline-block", marginRight: "0.5rem" }}
            >
              {word}
            </motion.span>
          ))}
        </h2>
        <p className="font-mulish">
          Keep your vehicle running safely and reliably while saving on
          essential maintenance and repair services. Take advantage of our
          latest special offers.
        </p>
      </div>
      <div className="service-three-right">
        <div className="step-box">
          {/* <span className="step-number">01</span> */}
          <div>
            <h4 className="chakra-petch-bold">
              FREE CHECK ENGINE DIAGNOSTIC SCAN CAR
            </h4>
            <p className="font-mulish">
              Is your check engine light on? Bring your vehicle in for a FREE
              diagnostic scan. Our technicians will identify fault codes and
              explain the issue, helping you make an informed decision before
              any repairs are carried out.
            </p>
          </div>
        </div>
        <div className="step-box">
          {/* <span className="step-number">02</span> */}
          <div>
            <h4 className="chakra-petch-bold">Refer a Friend & Save 10%</h4>
            <p className="font-mulish">
              Share the quality service with your friends and family! When you
              refer a friend to our workshop and they complete a service or
              repair, both you and your friend will receive 10% OFF labour on
              your next service. It's our way of saying thank you for your trust
              and support while helping your friends keep their vehicles running
              at their best.
            </p>
          </div>
        </div>
        <div className="step-box">
          {/* <span className="step-number">03</span> */}
          <div>
            <h4 className="chakra-petch-bold">
              INTERNAL TRANSMISSION REPAIR: $100 OFF
            </h4>
            <p className="font-mulish">
              Has your request been confirmed? Reduce no-shows, save time, and
              focus on serving clients is our top criterion.
            </p>
          </div>
        </div>
        <div className="step-box">
          {/* <span className="step-number">04</span> */}
          <div>
            <h4 className="chakra-petch-bold">
              ANNUAL TECHNICAL INSPECTION OF CARS
            </h4>
            <p className="font-mulish">
              Ensure your vehicle remains safe, reliable, and roadworthy with
              our comprehensive annual vehicle inspection. Our technicians
              inspect key safety and mechanical components in accordance with
              industry standards, providing you with confidence and peace of
              mind on every journey. Book your appointment today and take
              advantage of these limited-time offers while keeping your vehicle
              in top condition.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceFive;
